// extracted by mini-css-extract-plugin
export default {"item":"styles_item__Nqrcp","header":"styles_header__Tejx+","title":"styles_title__XoJWM","icon":"styles_icon__U8nYi","activeLink":"styles_activeLink__QYPy6"};